import fetchData from './fetchData'
import { parseJSON, checkHttpStatus } from '../shared/utils'
import config from '../config/index'

async function loginApp(payload) {
  return fetchData(
    `${config.api.baseUrl}?class=auth&action=login`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

export { loginApp }



// WEBPACK FOOTER //
// src/api/auth.js